export enum SchoolAggregationType {
  BRAND = 'BRAND',
  REGIONAL = 'REGIONAL',
  PREFECTURE = 'PREFECTURE',
}
